module.exports = __webpack_public_path__ + "media/images/instagram-icon-f1f1c5b15df0ef99b96d442fe7c0cbc6.svg";